import $ from 'Vendor/jquery'
import Logger from 'Vendor/@openmind/litelog'

import Map from '../../map'
import BaiduMarker from './baidumarker'

const Log = new Logger("StoreLocator/BaiduMap");

const ZOOMS = [ 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19 ];

class BaiduMap extends Map {



  constructor(provider, element, options) {
    super(provider, element)

    this.BOUNDS_CHANGED_EVENT_NAME = "moving"
    this.IDLE_EVENT_NAME = "tilesloaded"
    this.SELECTPOINT_EVENT_NAME = "selectpoint"
    this.ZOOM_CHANGED_EVENT_NAME = "zoomend"
    this.DRAGEND_EVENT_NAME = "dragend"

    const assign = Object.assign({},
  {
            //http://lbsyun.baidu.com/cms/jsapi/reference/jsapi_reference.html#a0b1 -> MapOptions
            minZoom: 3,
            maxZoom: 19,
            //mapType -> Map type, default is BMAP_NORMAL_MAP
            //enableHighResolution -> Whether to enable the use of high-resolution maps. On iPhone4 and subsequent devices, you can get a higher resolution basemap by turning on this option. The v1.2 and v1.3 versions are not enabled by default, and v1.4 is enabled by default
            //enableAutoResize -> Whether to automatically adapt to map container changes, enabled by default
            //enableMapClick -> Whether to enable the clickable basemap function, enabled by default
            zoom: 8, // custom
          }
          ,options
    );

    this.options=assign;
    this.options["markerkey"] = assign["markerkey"] || "name";

    let p = new Promise( (resolve) => {

      // Get the DOM element which use map in
      let mapEl = this.$element[0];

      // Use BaiduMap with default options
      this.Map = new window.BMap.Map(mapEl, assign);


      this.Data = {};

      this.Map.addEventListener("tilesloaded", () => {
        resolve(this);
      });

      //per farla caricare è necessario per forza dare delle coordinate, quindi ho messo quelle di pechino

      const {center, zoom}=assign;
      const {lat,lng}=center||{};

      this.Map.centerAndZoom(new window.BMap.Point(lng || 116.51288495608856, lat|| 39.84746927558593),zoom);

    });

    this._markers = {};

    return p;
  }


  /**
   * @Override
   */
  navigate(bounds, switching) {
    //debugger;

    if(!bounds.getCenter){
      // Move map to given bounds coordinates
      this.Map.setViewport( bounds );
      return bounds;
    }

  };


  /**
   * @Override
   */
  addPointToViewport(point) {
    //debugger;
    const p = new window.BMap.Point(point.lng, point.lat);
    const bounds=this.Map.getBounds();
    const b = new window.BMap.Bounds( bounds.getSouthWest(), bounds.getNorthEast() );
    b.extend( p );
    return b;
  };

  static viewportFromBoundAndPoint(bounds, points){
    //debugger;
    const b = new window.BMap.Bounds( bounds.getSouthWest(), bounds.getNorthEast() );
    for(let point of points) {
      const cords = point.geometry.coordinates;
      b.extend(new window.BMap.Point(cords[0], cords[1]));
    }
    return b;
  }

  /**
   *
   * @param bounds -> seguono il modello di Baidu
   * @param points -> dallo store locator e seguono il modello di google map....
   * @returns un array contenente i punti così come sono stati caricati dallo store locator
   */
  static includePinsIfInBound(bounds, points){
    //debugger;
    let pins = [];
    const b = new window.BMap.Bounds( bounds.getSouthWest(), bounds.getNorthEast() );
    let pointToFilter = points || [];
    for( let point of pointToFilter ) {
      const cords = point.geometry.coordinates;
      if ( b.containsPoint( new window.BMap.Point(cords[0], cords[1]) ) ) {
        pins.push( point );
      }
    }

    return pins;
  }


  /**
   * @Override
   */
  set center(point) {
    if ( !(point instanceof window.BMap.Point) ) {
      point = new window.BMap.Point( point );
    }
    this.Map.centerAndZoom(point,this.Map.getZoom());
  };

  /**
   * @Override
   */
  get zoom() {
    // returns the index of zoom level
    return ZOOMS.indexOf( this.Map.getZoom() );
  }

  set zoom(index) {
    // Sets zoom level if contained into `ZOOMS` array
    ZOOMS[ index ] && this.Map.setZoom( ZOOMS[ index ] );
  }


  get Markers() {
    //debugger;
    return this._markers;
  }

  getMarker(code) {
    //debugger;
    return this.Markers[ code ];
  }


  /**
   * @Override
   */
  showMarker(points, use_cluster) {
    //debugger;
    // remove all markers
    this.clearMarkers();

    let markers = [];
    let clusterMarkers=[];

    if ( points && points.features && points.features.length > 0 ) {

      if(points){
        for (let feature of points.features) {
          let d = this._parseFeatureData(feature);
          let marker = new BaiduMarker(
              feature.geometry,
              d,
              this
          );

          marker.on('click', (marker) => {
            this.trigger("selectpoint", marker);
          });

          // store all marker into a collection
          this._markers[  d[ this.options['markerkey'] ]   ] = marker;
          markers.push( marker );
          clusterMarkers.push( marker.marker );
        }
      }

      if ( use_cluster ) {
        const baiduOptions = this.provider.options.ClustersOpt.Baidu;
        const {ClusterImagePath,ClusterImageExt,ClusterMaxZoom,ClusterMinSize,ClusterGridSize} = baiduOptions;
        const url = ClusterImagePath+'.'+ClusterImageExt;

        if ( ! this.Clusters ) {
          // create a new clusterer class
          this.Clusters = new window.BMapLib.MarkerClusterer(this.Map, {
            averageCenter: true,
            styles: [{
              url,
              size: new window.BMap.Size(40, 40),
              opt_anchor: [16, 0],
            }]
          });
          if ( ClusterMaxZoom ) {
            this.Clusters.setMaxZoom(ClusterMaxZoom);
          }
          if ( ClusterMinSize ) {
            this.Clusters.setMinClusterSize(ClusterMinSize);
          }
          if ( ClusterGridSize ) {
            this.Clusters.setGridSize(ClusterGridSize);
          }
        }

        this.Clusters.addMarkers(clusterMarkers);

      }else{
        for(const m of clusterMarkers){
          this.Map.addOverlay(m)
        }
      }
    }

    return markers;

  };


  /**
   * Clears and removes all marker pin from Map
   */
  clearMarkers() {
    //debugger;
    if ( this.Clusters ) {
      this.Clusters.clearMarkers()
    }

    if ( this._markers ) {
      for( let code in this._markers ) {
        if ( this._markers.hasOwnProperty(code) ) {
          this._markers[ code ].map = null;
        }
      }

    }

    this._markers = {};

  }


  addMarkersToMap(markers, cluster) {
    //debugger;

    const fnAdded = (gmarker) => {
      gmarker.on('click', (marker) => {
        this.trigger("selectpoint", gmarker);
      });

      if ( cluster && this.Clusters ) {
        this.Clusters.addMarker( gmarker.marker );
      }
      let key = gmarker.get( this.options['markerkey'] );

      // store all marker into a collection
      this._markers[ key ] = gmarker;
    };

    // Reset `Data` and manage new Marker
    this.Map.addEventListener("addoverlay", (e) => {
      // create a BaiduMarker wrapper
      let d = this._parseFeatureData(e.feature);
      let gmarker = new BaiduMarker(e.feature.getGeometry, d, this);
      fnAdded( gmarker );
    });

    // Loop on markers
    for ( let marker of markers ) {

      if ( marker instanceof BaiduMarker ) {
        // Add a new BaiduMarker to collection of Markers
        marker.map = this;

        fnAdded( marker );

      } else {
        // Add marker as 'geojson' data
        this.Map.addOverlay( marker );

      }

    }
  }

  addIconMarker(lat,lng,{Url,Size}) {

    const m=new BaiduMarker(
        new window.BMap.Point(lng,lat),
        {}
    )
    m.image={Url,Size};
    this.Map.addOverlay(m.marker);
    //this.Map.panTo(m.marker.point)
    return m;
  }

  _parseFeatureData(feature) {
    const data = {};
    for (const [k,v] of Object.entries(feature)) {
      if(typeof v === "object"){
        for (const [k2,v2] of Object.entries(v)) {
          data[ k2 ] = v2;
        }
      }else{
        data[k]=v;
      }
    }

    return data;
  }


  /**
   * @Override
   */
  on(ev, fn){
    const eventName = "on"+ev;
    const eventsListeners = this.Map.Li || {};
    const eventCallbacks = eventsListeners[eventName] || [];
    const previousCallbacks=Object.keys(eventCallbacks);
    this.Map.addEventListener(ev, fn);
    const newCallbacks = Object.keys(eventCallbacks).filter(e=>!previousCallbacks.includes(e));
    if(newCallbacks && newCallbacks[0]){
      return eventCallbacks[newCallbacks[0]];
    }
  };

  /**
   * @Override
   */
  off(ev){
    if ( typeof ev == 'string' ) {
      const eventName = "on"+ev;
      const eventsListeners = this.Map.Li || {};
      const eventCallbacks = eventsListeners[eventName] || [];
      for(const e in eventCallbacks){
        this.Map.removeEventListener(ev,eventCallbacks[e]);
      }
    } else {
      this.Map.removeEventListener(Object.keys(ev.nl)[0],ev);
    }
    return this;
  }


  /**
   * @Override
   */
  trigger(ev, ...args) {
    let E = $.Event(ev);
    this.Map.dispatchEvent(E, ...args);
    //this.Map.dispatchEvent.apply(this.Map, [this.Map, E.type, E, ...args] );;
    return this;
  };


  /**
   * @Override
   */
  get viewport(){ return this.bounds; }
  get bounds(){ return this.Map.getBounds(); }
  get center(){ return this.Map.getCenter(); }

  /**
   * @Override
   */
  drawOnMap(bounds, color, line) {

  };


  clone(element, options) {
    return new BaiduMap(this.provider, element, $.extend(true, {}, this.options, options) );
  }

  getBoundsFromCoords(bounds) {
    //debugger;
    const neP=bounds.getNorthEast()
    const swP=bounds.getSouthWest()

    const sw = new window.BMap.Point(swP.lng, swP.lat);
    const ne = new window.BMap.Point(neP.lng, neP.lat);
    return new window.BMap.Bounds( sw, ne );
  };


  // Stores MapEngine into MapProvider
  // MapProvider.addEngine("BaiduMap", constructor);

}

export {BaiduMap, BaiduMarker}
